module.exports = __webpack_public_path__ + "static/media/icon-prev.0fa4e8f2.svg";